export default __webpack_public_path__ + "static/thumb-landscape-6d69a89986a0ca61291d41619270e80f.jpg";